import { call, put } from 'redux-saga/effects'

import {
  calculateBasketPriceSuccess,
  calculateBasketPriceFailure
} from '../../actionCreators/calculateBasketPrice/calculateBasketPriceActionCreators'

import { fetchApi } from '../helpers/fetchApi'

import Logger from '../../helpers/Logger'

const logger = Logger.getInstance()
const endpoint = '/product-api/calculate-basket-price'

function* basketPriceSaga(action) {
  const { payload } = action
  const queryData = encodeURIComponent(
    JSON.stringify({
      items: payload
    })
  )
  try {
    const jsonData = yield call(fetchApi, endpoint, { data: queryData })
    const successAction = calculateBasketPriceSuccess(jsonData)
    return yield put(successAction)
  } catch (error) {
    const failureAction = calculateBasketPriceFailure({ payload, errorDetail: error })
    logger.error(
      'Calculate Special Offers Price error',
      { payload, errorDetail: error },
      'Calculate Special Offers Price error'
    )
    return yield put(failureAction)
  }
}

export { endpoint, basketPriceSaga }
